// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qo_a bic_sn bic_va","ForumSearch__img":"qo_b","ForumSearch__searchAdsAndShoppingAds":"qo_c","ForumSearch__results--empty":"qo_e"};